import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAgentAccess } from "@/hooks/useAgentAccess";
import { AGENT_CATALOG } from "@/lib/agent-catalog";
import { ArrowRight } from "lucide-react";

export default function MobileAgentsDirectory() {
  const { agents, error, isLoading } = useAgentAccess();

  if (isLoading) {
    return <div className="p-6 text-sm text-slate-500">Cargando agentes...</div>;
  }

  if (error) {
    return <div className="p-6 text-sm text-red-600">No se pudieron cargar los agentes: {error}</div>;
  }

  const visibleAgents = (agents || []).filter((agent) => AGENT_CATALOG[agent.id]);
  const withSpecialized = visibleAgents.some((agent) => agent.id === "specialized")
    ? visibleAgents
    : [{ id: "specialized", name: "Agentes Especializados", description: "" } as any, ...visibleAgents];

  return (
    <div className="p-4 sm:p-6">
      <div className="mb-5 flex items-center gap-2">
        <h1 className="text-xl font-semibold text-slate-900">Agentes IA</h1>
        <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-100">Mobile</Badge>
      </div>

      <div className="space-y-3">
        {withSpecialized.map((agent) => {
          const catalogItem = AGENT_CATALOG[agent.id];
          if (!catalogItem) return null;
          const Icon = catalogItem.icon;

          const targetUrl = catalogItem.path || `/dashboard/agents/mobile/${agent.id}`;
          return (
            <Link key={agent.id} to={targetUrl}>
              <Card className="border-slate-200 hover:border-blue-300 transition-colors">
                <CardHeader className="pb-2">
                  <div className="flex items-center justify-between gap-3">
                    <div className={`h-10 w-10 rounded-xl bg-gradient-to-br ${catalogItem.gradient} flex items-center justify-center`}>
                      <Icon className="h-5 w-5 text-white" />
                    </div>
                    <ArrowRight className="h-4 w-4 text-slate-400" />
                  </div>
                  <CardTitle className="text-base">{catalogItem.name}</CardTitle>
                  <CardDescription>{catalogItem.description}</CardDescription>
                </CardHeader>
                <CardContent className="pt-0 text-xs text-blue-600 font-semibold flex items-center gap-1">
                  Abrir asistente <ArrowRight className="h-3 w-3" />
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
